import {
  Text,
  Tag,
  TagLabel,
  Box,
  Wrap,
  WrapItem,
  useToast,
} from "@chakra-ui/react";
import * as N from "../../utilities/notifications";
import { showIcon } from "../../utilities/render-helpers/renderPractitionerSearch";
import { useEffect, useState } from "react";

const Lozenge = ({
  title,
  data,
  onclick,
  multi = false,
  initialshow = null,
  max = null,
  nullOption = null,
  size = "lg",
  error = false,
  allowDeselect = false,
  required = false,
}) => {
  // Expects a JSON array
  // [{value: val, label: "label"}]

  const [nullOptionSelected, setNullOptionSelected] = useState(
    nullOption !== null ? nullOption.selected : false
  );

  useEffect(() => {
    data?.filter((elem) => elem.selected).length
      ? setNullOptionSelected(false)
      : setNullOptionSelected(true);
  }, [data]);

  const toast = useToast();
  // return if undefined
  if (data === undefined) return null;
  if (data === "undefined") return null;
  if (data.length === 0) return null;

  // update lozenge preferences
  const toggleLozenge = (val) => {
    let newArr = [];
    if (multi) {
      // check if max size set and reached

      if (
        max !== null &&
        Number(data.filter((elem) => elem.selected).length) >= Number(max)
      ) {
        let isElemToBeAdded = data.filter((elem) => elem.value === val);

        if (!isElemToBeAdded[0].selected) {
          toast(N.maxSelection(max));
          return data;
        }
      }
      newArr = data.map((item) => {
        return item.value === val
          ? { ...item, selected: !item.selected }
          : item;
      });
    } else {
      newArr = data.map((item) => {
        if (item.value === val) {
          return {
            ...item,
            selected: allowDeselect ? !item.selected : true,
          };
        }
        return { ...item, selected: false };
      });
      setNullOptionSelected(false);
    }

    return newArr;
  };

  const clearLozenges = () => {
    let newArr = data.map((item) => ({ ...item, selected: false }));
    setNullOptionSelected(true);
    return newArr;
  };

  return (
    <Box>
      {title !== "" && (
        <Text pb="8px" textStyle="h6">
          {required && (
            <Text display="inline-block" color="red">
              *
            </Text>
          )}
          {title}
        </Text>
      )}
      <Wrap
        p={error ? 1 : 0}
        borderRadius={error ? "0.375rem" : 0}
        borderWidth={error ? 2 : 0}
        borderColor={error ? "#E53E3E" : "transparent"}
      >
        {nullOption && !multi && (
          <WrapItem key={data.length + 1}>
            <Tag
              key={`tag${data.length + 1}`}
              cursor="pointer"
              size={size}
              borderRadius="full"
              variant={nullOptionSelected ? "solid" : "unselected"}
              bg={nullOptionSelected ? "brand.300" : "brand.100"}
              color={nullOptionSelected ? "white" : "brand.300"}
              border="none"
              //colorScheme="secondary"
              onClick={() => onclick(clearLozenges())}
            >
              {showIcon(nullOption.icon, nullOptionSelected)}
              <TagLabel
                sx={{
                  wordWrap: "anywhere",
                  overflowWrap: "anywhere",
                }}
              >
                {nullOption.label}
              </TagLabel>
            </Tag>
          </WrapItem>
        )}
        {data.map(({ value, label, selected, icon }, idx) => {
          return initialshow !== null && idx > initialshow - 1 ? null : (
            <WrapItem key={idx}>
              <Tag
                key={`tag${idx}`}
                cursor="pointer"
                size={size}
                borderRadius="full"
                variant={selected ? "solid" : "unselected"}
                bg={selected ? "brand.300" : "brand.100"}
                color={selected ? "white" : "brand.300"}
                border="none"
                //colorScheme="secondary"
                onClick={() => onclick(toggleLozenge(value))}
              >
                {showIcon(icon, selected)}
                <TagLabel
                  sx={{
                    wordWrap: "anywhere",
                    overflowWrap: "anywhere",
                  }}
                >
                  {label}
                </TagLabel>
              </Tag>
            </WrapItem>
          );
        })}
      </Wrap>
    </Box>
  );
};

export default Lozenge;
